import { Box, Alert } from '@mui/material'
import Modal from '@mui/material/Modal'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../global/components/buttons/secondary-button/SecondaryButton'
import styles from './styles.module.css'

interface ConfirmActionModalProps {
  isOpen: boolean
  title: string
  message: string
  confirmLabel: string
  onConfirm: () => void
  onCancel: () => void
  isLoading?: boolean
  severity?: 'warning' | 'error' | 'info'
}

export default function ConfirmActionModal({
  isOpen,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  isLoading = false,
  severity = 'warning',
}: ConfirmActionModalProps) {
  return (
    <Modal
      open={isOpen}
      aria-labelledby='confirm-modal-title'
      aria-describedby='confirm-modal-description'
      onClose={onCancel}
    >
      <Box className={styles.confirmModal}>
        <div className={styles.confirmModalTitle}>{title}</div>
        <Alert severity={severity} sx={{ width: '100%' }}>
          {message}
        </Alert>
        <div className={styles.confirmModalButtons}>
          <SecondaryButton
            buttonName='Cancel'
            onClick={onCancel}
            disabled={isLoading}
          />
          <PrimaryButton
            buttonName={isLoading ? 'Processing...' : confirmLabel}
            onClick={onConfirm}
            disabled={isLoading}
          />
        </div>
      </Box>
    </Modal>
  )
}
